import React, { useContext } from "react";
import { Button } from "semantic-ui-react";
import { useMutation } from "react-query";
import { NotificationContext } from "../../../../../notifications";
import { Trans, useTranslation } from "react-i18next";
import { MUTATIONS } from "../../../../../../_api/queries";
import InfoIcon from "../../../../../layout/Icons/Info";
import { ModalLayoutRevised } from "../../../../../common/ModaLayoutRevision/ModalLayoutRevised";
import { LoadingScreen } from "mapsted-components";
export const DeleteClaimModal = ({
    claimName,
    claimId,
    refetchData,
    handleHideModel,
}) => {
    const trans = useTranslation().t("Sso.DeleteClaimModal");

    const notifications = useContext(NotificationContext);
    const { mutateAsync, isLoading, reset } = useMutation(
        MUTATIONS.sso.DELETE_CLAIM(refetchData)
    );

    const handleDeleteClaim = async (evt) => {
        try {
            const responseData = await mutateAsync(claimId);
            // reset();
            if (responseData !== true) {
                throw new Error(`${responseData || "Unknown error"}`);
            }

            handleHideModel();
            return;
        } catch (err) {
            // eslint-disable-next-line no-debugger
            notifications.addNotification(
                "danger",
                "Delete Claim Failed",
                err.message
            );

            handleHideModel();
        } finally {
            reset();
        }
    };

    return (
        <ModalLayoutRevised
            open={true}
            onClose={() => handleHideModel()}
            size="mini"
            hideClose={true}
            // regularModal={true}
            className={"DeleteClaimModal"}
            actions={
                <>
                    <Button
                        color="orange"
                        type="button"
                        floated="right"
                        content={"Confirm"}
                        className="submit-btn"
                        onClick={handleDeleteClaim}
                    />
                    <Button
                        type="button"
                        floated="left"
                        content={"Cancel"}
                        className="cancel-btn"
                        onClick={() => {
                            handleHideModel();
                        }}
                    />
                </>
            }
        >
            <div className="delete-confirm">
                {isLoading && <LoadingScreen />}
                <InfoIcon />
                <h3 className="delete-confirm-title">
                    {trans["Delete_Claim"]}
                </h3>
                <p className="delete-confirm-sub-title">
                    <Trans
                        i18nKey="Sso.DeleteClaimModal.Confirmation_Msg_1"
                        values={{ claimName }}
                    />
                </p>
                <p className="delete-confirm-sub-title">
                    <Trans i18nKey="Sso.DeleteClaimModal.Confirmation_Msg_2" />
                </p>
            </div>
        </ModalLayoutRevised>
    );
};
